import {PERMISSION_GROUP_NOT_RESTRICTED} from '../constants/ModelConstants'

/**
 * @param {Array<string>} residentGroups
 * // you can pass either an array of strings or objects with value/label keys, or a lookup object (value: label)
 * @param {Array<string|{value: string, label: string}>|Object<string, string>} allGroups
 * @returns string
 */
export function getResidentGroupsLabel(residentGroups, allGroups) {
  if (!residentGroups || residentGroups.length === 0 || residentGroups.length === allGroups.length) {
    return 'All'
  }

  let groupLookup = allGroups
  if (Array.isArray(allGroups)) {
    // convert allGroups to a lookup map
    groupLookup = allGroups.reduce((map, group) => {
      if (typeof group === 'string') {
        map[group] = group
      } else if (group && group.value) {
        map[group.value] = group.label || group.value
      }
      return map
    }, {})
  }

  return residentGroups.map(rG => groupLookup[rG]).join(', ')
}

export function isGlobalAdminUserType(organization, staff) {
  return (
    organization &&
    Array.isArray(organization.ownerIds) &&
    organization.ownerIds.includes(staff.id) &&
    staff.permissionGroup === PERMISSION_GROUP_NOT_RESTRICTED
  )
}
